.search {
  margin: 0 0 24px;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: var(--label);
}

.input {
  height: 52px;
  padding: 0 22px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
  background: var(--card);
  /* 16 px: iOS Safari zooms into any smaller field on focus. */
  font: 400 16px var(--font-body);
  color: var(--text);
}

.input:focus-visible {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(122, 84, 52, 0.18);
}

.input::placeholder {
  color: var(--text-muted);
}

.status {
  margin: 0 0 20px;
  font-size: 14px;
  color: var(--text-secondary);
}

.clear {
  min-height: 44px;
  padding: 0 4px;
  border: 0;
  background: none;
  font: 500 14px var(--font-body);
  color: var(--primary);
  text-decoration: underline;
  cursor: pointer;
}
